var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RegularHelpPage',{attrs:{"AppThemeSetting":_vm.AppThemeSetting,"nameOfPage":'OfferingPage'}})}
var staticRenderFns = []

export { render, staticRenderFns }